export const QUESTIONNAIRE = {
    ENABLE: 'QUESTIONNAIRE_ENABLE',
    DISABLE: 'QUESTIONNAIRE_DISABLE',
    SAVE_RESPONSES: 'QUESTIONNAIRE_SAVE_RESPONSES',
    SAVE_RESULT: 'QUESTIONNAIRE_SAVE_RESULT',
    SET_CONDITIONS_MET: 'SET_CONDITIONS_MET',
    SUBMIT: 'QUESTIONNAIRE_SUBMIT',
    RESET: 'QUESTIONNAIRE_RESET'
};

export const QUESTIONNAIRE_TYPES = {
    STATIC: 'formStatic',
    DYNAMIC: 'formDynamic'
};

export const REJECT_CODES = {
    USABILA_COOKIE_PRESENT: 'USABILA_COOKIE_PRESENT',
    AGENT_NOT_JOINED: 'AGENT_NOT_JOINED',
    NO_CLIENT_MESSAGES: 'NO_CLIENT_MESSAGES',
    CONVERSATION_TOO_SHORT: 'CONVERSATION_TOO_SHORT',
    SESSION_FAIL: 'SESSION_FAIL',
    TRANSFER_WITHOUT_AGENT: 'TRANSFER_WITHOUT_AGENT',
    NO_QUESTIONNAIRE_CONFIG: 'NO_QUESTIONNAIRE_CONFIG',
    B2B_HIGH_SEGMENT: 'B2B_HIGH_SEGMENT'
};
